import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({
    name: 'formatIfNumber'
})
export class FormatIfNumberPipe implements PipeTransform {

    transform(input: string, maxDecimals: Number): any {

        if (isNaN(Number(input))) {
            return input;
        }

        return String(formatNumber(Number(input), 'en-US', `1.0-${maxDecimals}`));
    }
}
